import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { ISiteUserInfo } from '../models/ISiteUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { SiteUsers } from '../resources/SiteUsers';
import { IUserActionResult } from '../ServerApi/types/IUserActionResult';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ServerService } from './ServerService';
import { UserActionNotification, UserActionNotificationParams } from './UserActionNotification';

export class RemoveUsersFromSiteAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'UserActionNotification',
                           'ServerService',
                           'SiteUsers'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private userActionNotification: UserActionNotification,
    private serverService: ServerService,
    private SiteUsers: SiteUsers) { }

  public showRemoveUsersFromSiteDialog(
    siteUsersToRemove: Set<ISiteUserInfo>,
    context: IActionContext): ng.IPromise<any> {

    const dialogBody = this.$translate.instant('confirmRemoveUsersFromSite', {
      USER_NAME: L10n.elideIfLong(siteUsersToRemove.first().displayName),
      USER_COUNT: siteUsersToRemove.size(),
      SITE_NAME: L10n.elideIfLong(this.serverService.sessionSiteName())
    }, L10n.Interpolations.Count);

    const dialogInstance = this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('remove'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmRemoveButton', {
        ITEM_COUNT: siteUsersToRemove.size()
      }, L10n.Interpolations.Count),
      action: () => this.SiteUsers.deleteUsers(siteUsersToRemove.keys()),
      isDeleteAction: true
    });

    dialogInstance.result.then((result: IUserActionResult) => {
      const params: UserActionNotificationParams = {
        users: siteUsersToRemove,
        results: result.results,
        errors: result.errors,
        successCode: '13',
      };
      this.userActionNotification.notify(params);
    });

    return dialogInstance.result;
  }

}

Module.instance().service('RemoveUsersFromSiteAction', RemoveUsersFromSiteAction);
